(function () {
  if (window.__leoCart) return;
  window.__leoCart = true;
  function drawer() { return document.querySelector('cart-drawer'); }
  function url(key, fallback) { return (window.routes && window.routes[key]) || fallback; }
  function busy(on) {
    var inner = document.querySelector('cart-drawer .lc-inner');
    if (inner) inner.classList.toggle('lc-loading', on);
  }
  function render(json) {
    var d = drawer();
    if (!d || !json || !json.sections || typeof d.renderContents !== 'function') { location.reload(); return; }
    d.renderContents(json);
    if (typeof json.item_count === 'number') d.classList.toggle('is-empty', json.item_count === 0);
    else d.classList.remove('is-empty');
  }
  function post(endpoint, body) {
    busy(true);
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status && json.description) { alert(json.description); return; }
        render(json);
      })
      .catch(function () { location.reload(); })
      .finally(function () { busy(false); });
  }
  document.addEventListener('click', function (e) {
    var d = e.target.closest ? e.target.closest('cart-drawer') : null;
    if (!d) return;
    var q = e.target.closest('[data-lc-line]');
    if (q) {
      e.preventDefault();
      post(url('cart_change_url', '/cart/change') + '.js', { line: parseInt(q.dataset.lcLine, 10), quantity: Math.max(0, parseInt(q.dataset.lcQty, 10)) });
      return;
    }
    var a = e.target.closest('[data-lc-add]');
    if (a) {
      e.preventDefault();
      var card = a.closest('.lc-up');
      var v = card && card.querySelector('[data-lc-variant]');
      if (!v || !v.value) return;
      post(url('cart_add_url', '/cart/add') + '.js', { items: [{ id: parseInt(v.value, 10), quantity: 1 }] });
    }
  });
})();
